import type { VoidFunctionComponent } from 'react';

import { confidenceFilterOptions } from '../../../../shared/snippets';
import { selectOptionFactory } from '../../../utils';
import { Select } from '../../generic';
import type { ConfidenceFilterOption } from '../../../../shared/snippets';

export type Props = {
  /**
   * The initial search value.
   */
  initialValues: ConfidenceFilterOption[];
  /**
   * Callback function to handle debounced changes to the search input.
   */
  onFilterChange: (values: ConfidenceFilterOption[]) => void;
};

const confidenceFilterLabels: Record<ConfidenceFilterOption, string> = {
  high: 'High',
  low: 'Low',
};

const confidenceFilterSelectOptions = confidenceFilterOptions.map(
  (option) => selectOptionFactory(option, confidenceFilterLabels[option]),
);

/**
 * This component renders a multi-select dropdown menu for filtering snippets by confidence.
 */
const ConfidenceFilter: VoidFunctionComponent<Props> = ({ initialValues, onFilterChange }) => {
  const values = initialValues.map((value) => selectOptionFactory(value, confidenceFilterLabels[value]));
  return (
    <Select
      id="snippets-confidence-filter"
      isMulti
      isClearable
      placeholder="Confidence"
      options={confidenceFilterSelectOptions}
      value={values}
      onChange={(newValues) => onFilterChange(newValues.map((option) => option.value))}
    />
  );
};

export default ConfidenceFilter;
